import React, { Component } from 'react'
import { Navbar, Nav, Container, Button, Dropdown, Card } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.css';
import bootstrap from 'bootstrap'
import FeatherIcon from 'feather-icons-react';
import '../css/BoxItem.css'; // Tell webpack that Button.js uses these styles
import Swal from 'sweetalert2/dist/sweetalert2.js';
import axiosConfig from '../config/axiosConfig'


class BoxCard extends React.Component {
    constructor(props) {
        super(props);
        this.swalConfirm = this.swalConfirm.bind(this)
    }

    swalConfirm(PAN) {

        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((result) => {
            if (result.isConfirmed) {
                
                axiosConfig.post("Portal/DeleteCardMapping",
                    {
                        
                            AccountsUserBranchId: this.props.data.selectedBranchId,
                            PAN: PAN
                        
                    }
                )
                    .then(Response => {


                        Swal.fire(
                            'Deleted!',
                            'Item has been deleted',
                            'success'
                        )

                        console.log(Response.data)
                        localStorage.setItem('tabClosed', 'false');
                        window.location.reload();
                    })
                    .catch(error => {
                        console.log("Error !! Not deleted PAN")

                        Swal.fire(
                            'Error',
                            'Error! Please try again',
                            'error'
                        )
                    })

            }
            console.log("need to delete PAN", PAN)
        })
    }

    render() {
        return (
            <div>
                {this.props.deleteDialog == 'yes' ?

                    <div className="box-item btn btn-default w-100 tt">{this.props.divText}<a data-action="close" style={{ float: 'right' }} onClick={() => this.swalConfirm(this.props.divText)}><FeatherIcon className="iconspacing" icon="x-circle" size="15" /></a></div> :

                    <div className="box-item btn btn-default w-100 tt">{this.props.divText}</div>

                }

            </div>
        );
    }
}

export default BoxCard;